import { GET_SHORTEN_LINK } from '../commons/constants/apis';
import { ResponseTypes } from '../types/response';
import { ShortenLinkResponseTypes } from '../types/response/shortenLink';
import axios from './axios';

export const getShortenLink = async (url: string): Promise<ShortenLinkResponseTypes> => {
  const { data }: ResponseTypes<ShortenLinkResponseTypes> = await axios.post(GET_SHORTEN_LINK, {
    originalUrl: url,
  });

  return data;
};
